import React from 'react';

const Shimmer = ({ className = '' }) => (
  <div className={`animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 ${className}`} />
);

export const ShimmerAvatar = ({ size = 'h-24 w-24' }) => (
  <Shimmer className={`${size} rounded-full`} />
);

export const ShimmerText = ({ width = 'w-full', height = 'h-4' }) => (
  <Shimmer className={`${width} ${height} rounded`} />
);

export const ShimmerImage = ({ className = 'h-32 w-full' }) => (
  <Shimmer className={`${className} rounded-lg`} />
);

export const ShimmerCard = ({ children, className = '' }) => (
  <div className={`bg-white p-4 rounded-lg shadow ${className}`}>
    {children}
  </div>
);

export default Shimmer; 